var nm = "process completed";
var h = 400;
var w = 400;
var meta = {
	g: "@lottiefiles/toolkit-js 0.33.2"
};
var layers = [
	{
		ty: 4,
		nm: "tick",
		sr: 1,
		st: 0,
		op: 80,
		ip: 0,
		hasMask: false,
		ao: 0,
		ks: {
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				]
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				]
			},
			sk: {
				a: 0,
				k: 0
			},
			p: {
				a: 0,
				k: [
					200,
					195.652,
					0
				]
			},
			r: {
				a: 0,
				k: 0
			},
			sa: {
				a: 0,
				k: 0
			},
			o: {
				a: 0,
				k: 100
			}
		},
		ef: [
		],
		shapes: [
			{
				ty: "gr",
				nm: "tick",
				it: [
					{
						ty: "sh",
						nm: "Path 1",
						d: 1,
						ks: {
							a: 0,
							k: {
								c: false,
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-69.565,
										4.348
									],
									[
										-26.087,
										47.826
									],
									[
										69.565,
										-47.826
									]
								]
							}
						}
					},
					{
						ty: "st",
						nm: "Stroke 1",
						lc: 2,
						lj: 2,
						ml: 1,
						o: {
							a: 0,
							k: 100
						},
						w: {
							a: 0,
							k: 26.087
						},
						c: {
							a: 0,
							k: [
								1,
								1,
								1
							]
						}
					},
					{
						ty: "tr",
						a: {
							a: 0,
							k: [
								0,
								0
							]
						},
						s: {
							a: 0,
							k: [
								100,
								100
							]
						},
						sk: {
							a: 0,
							k: 0
						},
						p: {
							a: 0,
							k: [
								0,
								0
							]
						},
						r: {
							a: 0,
							k: 0
						},
						sa: {
							a: 0,
							k: 0
						},
						o: {
							a: 0,
							k: 100
						}
					}
				]
			},
			{
				ty: "tm",
				nm: "Trim Paths 1",
				e: {
					a: 1,
					k: [
						{
							o: {
								x: 0.75,
								y: 0
							},
							i: {
								x: 0.67,
								y: 1
							},
							s: [
								0
							],
							t: 45
						},
						{
							s: [
								100
							],
							t: 65
						}
					]
				},
				o: {
					a: 0,
					k: 0
				},
				s: {
					a: 0,
					k: 0
				},
				m: 1
			}
		],
		ind: 1
	},
	{
		ty: 4,
		nm: "bg",
		sr: 1,
		st: 0,
		op: 80,
		ip: 0,
		hasMask: false,
		ao: 0,
		ks: {
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				]
			},
			s: {
				a: 1,
				k: [
					{
						o: {
							x: 1,
							y: 0
						},
						i: {
							x: 0.678,
							y: 1
						},
						s: [
							0,
							0,
							100
						],
						t: 32
					},
					{
						s: [
							100,
							100,
							100
						],
						t: 55
					}
				]
			},
			sk: {
				a: 0,
				k: 0
			},
			p: {
				a: 0,
				k: [
					200,
					200,
					0
				]
			},
			r: {
				a: 0,
				k: 0
			},
			sa: {
				a: 0,
				k: 0
			},
			o: {
				a: 0,
				k: 100
			}
		},
		ef: [
		],
		shapes: [
			{
				ty: "gr",
				nm: "bg",
				it: [
					{
						ty: "el",
						nm: "Ellipse Path 1",
						d: 1,
						p: {
							a: 0,
							k: [
								0,
								0
							]
						},
						s: {
							a: 0,
							k: [
								400,
								400
							]
						}
					},
					{
						ty: "fl",
						nm: "Fill 1",
						c: {
							a: 0,
							k: [
								1,
								0.737,
								0
							]
						},
						r: 1,
						o: {
							a: 0,
							k: 100
						}
					},
					{
						ty: "tr",
						a: {
							a: 0,
							k: [
								0,
								0
							]
						},
						s: {
							a: 0,
							k: [
								100,
								100
							]
						},
						sk: {
							a: 0,
							k: 0
						},
						p: {
							a: 0,
							k: [
								0,
								0
							]
						},
						r: {
							a: 0,
							k: 0
						},
						sa: {
							a: 0,
							k: 0
						},
						o: {
							a: 0,
							k: 100
						}
					}
				]
			}
		],
		ind: 2
	},
	{
		ty: 4,
		nm: "bg 2",
		sr: 1,
		st: 0,
		op: 80,
		ip: 0,
		hasMask: false,
		ao: 0,
		ks: {
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				]
			},
			s: {
				a: 1,
				k: [
					{
						o: {
							x: 0.33,
							y: 0
						},
						i: {
							x: 0.25,
							y: 1
						},
						s: [
							0,
							0,
							100
						],
						t: 27
					},
					{
						s: [
							100,
							100,
							100
						],
						t: 51
					}
				]
			},
			sk: {
				a: 0,
				k: 0
			},
			p: {
				a: 0,
				k: [
					200,
					200,
					0
				]
			},
			r: {
				a: 0,
				k: 0
			},
			sa: {
				a: 0,
				k: 0
			},
			o: {
				a: 0,
				k: 100
			}
		},
		ef: [
		],
		shapes: [
			{
				ty: "gr",
				nm: "bg",
				it: [
					{
						ty: "el",
						nm: "Ellipse Path 1",
						d: 1,
						p: {
							a: 0,
							k: [
								0,
								0
							]
						},
						s: {
							a: 0,
							k: [
								400,
								400
							]
						}
					},
					{
						ty: "fl",
						nm: "Fill 1",
						c: {
							a: 0,
							k: [
								1,
								1,
								1
							]
						},
						r: 1,
						o: {
							a: 0,
							k: 100
						}
					},
					{
						ty: "tr",
						a: {
							a: 0,
							k: [
								0,
								0
							]
						},
						s: {
							a: 0,
							k: [
								100,
								100
							]
						},
						sk: {
							a: 0,
							k: 0
						},
						p: {
							a: 0,
							k: [
								0,
								0
							]
						},
						r: {
							a: 0,
							k: 0
						},
						sa: {
							a: 0,
							k: 0
						},
						o: {
							a: 0,
							k: 100
						}
					}
				]
			}
		],
		ind: 3
	},
	{
		ty: 4,
		nm: "bg 3",
		sr: 1,
		st: 0,
		op: 80,
		ip: 0,
		hasMask: false,
		ao: 0,
		ks: {
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				]
			},
			s: {
				a: 1,
				k: [
					{
						o: {
							x: 1,
							y: 0
						},
						i: {
							x: 0.67,
							y: 1
						},
						s: [
							0,
							0,
							100
						],
						t: 5
					},
					{
						s: [
							100,
							100,
							100
						],
						t: 30
					}
				]
			},
			sk: {
				a: 0,
				k: 0
			},
			p: {
				a: 0,
				k: [
					200,
					200,
					0
				]
			},
			r: {
				a: 0,
				k: 0
			},
			sa: {
				a: 0,
				k: 0
			},
			o: {
				a: 0,
				k: 100
			}
		},
		ef: [
		],
		shapes: [
			{
				ty: "gr",
				nm: "bg",
				it: [
					{
						ty: "el",
						nm: "Ellipse Path 1",
						d: 1,
						p: {
							a: 0,
							k: [
								0,
								0
							]
						},
						s: {
							a: 0,
							k: [
								400,
								400
							]
						}
					},
					{
						ty: "fl",
						nm: "Fill 1",
						c: {
							a: 0,
							k: [
								1,
								0.792,
								0.224
							]
						},
						r: 1,
						o: {
							a: 0,
							k: 100
						}
					},
					{
						ty: "tr",
						a: {
							a: 0,
							k: [
								0,
								0
							]
						},
						s: {
							a: 0,
							k: [
								100,
								100
							]
						},
						sk: {
							a: 0,
							k: 0
						},
						p: {
							a: 0,
							k: [
								0,
								0
							]
						},
						r: {
							a: 0,
							k: 0
						},
						sa: {
							a: 0,
							k: 0
						},
						o: {
							a: 0,
							k: 100
						}
					}
				]
			}
		],
		ind: 4
	}
];
var v = "5.7.4";
var fr = 40;
var op = 80;
var ip = 0;
var assets = [
];
var animationData = {
	nm: nm,
	h: h,
	w: w,
	meta: meta,
	layers: layers,
	v: v,
	fr: fr,
	op: op,
	ip: ip,
	assets: assets
};

export { assets, animationData as default, fr, h, ip, layers, meta, nm, op, v, w };
//# sourceMappingURL=check.json.js.map
